import { memo } from '../util/memoizationUtils';
import BackendService from './BackendService';

export default class CarService {
  static memoizedGetCar = memo(CarService.nonMemoizedGetCar);

  static getCar(carId) {
    return CarService.memoizedGetCar(carId);
  }

  static nonMemoizedGetCar(carId) {
    return BackendService.get(`/cars/${carId}`);
  }

  static updateCar(carId, body) {
    return BackendService.put(`/cars/${carId}`, { body });
  }

  static getCarCards(query) {
    const params = { ...query };
    return BackendService.get(`/cars/filter/cards`, { params });
  }

  static getFilteredCards(filterQuery) {
    const params = { ...filterQuery };
    return BackendService.post(`/cars/filtered`, { params, body: filterQuery });
  }

  static create(car) {
    return BackendService.post('/cars', { body: car });
  }

  static markAvailable(carId) {
    return BackendService.post(`/cars/mark-available/${carId}`);
  }
}
